import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_CAPYBARA_HOMEPAGE_V3 = createFcmDetails('capybara_homepage_v3', {
	owner: 'capybara',
	context: 'HomepageV3 - Redesign of Homepage V2 top 2 panels',
	description:
		'Country+locale on/off switch and content for redesign of the top 2 panels of Homepage V2. If experiment is enabled, the layout object will determine which components are enabled.',
	import: false,
	template: {
		perLocaleConfig: {
			enabled: false,
			layout: { hero: false, howTo: false },
			tips: [
				{
					title: 'How to create a petition',
					guideLink: 'https://www.change.org/petition-guides/create-a-petition',
				},
			],
			topImpactStories: [
				{
					petitionId: '123456',
					summary: 'Top impact story summary',
					imageUrl: 'image.jpg',
					testimonialUrl: 'https://www.change.org/impact-stories/slug',
				},
			],
		},
	},
	mergeLogic: 'Displays in order of country, locale, then global',
});
